import isAddress from '@blockcatio/tabby-library/lib/utilities/isAddress';
import { getTokenDecimals } from '@blockcatio/tabby-library/lib/utilities/tokenUtilities';

/**
 * Get the proper number of decimals for a payment type, based on token address.
 * Default to 18, treat as ETH, if not a valid address.
 *
 * @param {String} tokenAddress
 * @param {Object[]} tokenList
 */
const getPaymentDecimals = (tokenAddress, tokenList) =>
  (isAddress(tokenAddress, true) ? getTokenDecimals(tokenList, tokenAddress) : 18);

export default getPaymentDecimals;



// WEBPACK FOOTER //
// ./src/utilities/getPaymentDecimals.js